import api from "@/api/axios";

const FILES_URL = "/files";

// Export as XLSX
export const exportUsersXLSX = () =>
  api.get(`${FILES_URL}/export`, { responseType: "blob" });

// Import XLSX
export const importUsersXLSX = (formData) =>
  api.post(`${FILES_URL}/import`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Trockenlauf: zaehlt, was der Import loeschen wuerde, und schreibt nichts.
export const previewImportXLSX = (formData) =>
  api.post(`${FILES_URL}/import/preview`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
